export interface Amenity {
  id: string;
  name: string;
  op: string;
}

export interface Floor {
  id: string;
  name: string;
  ordinality: number;
  image: string;
  op: string;
}

export interface Neighborhood {
  id: string;
  name: string;
  displayColor: string;
  op: string;
}

export interface ProfileData {
  id: string;
  avatarUrl: string;
  name: string;
}

interface CheckInStatus {
  status: 'PENDING' | 'CHECKED_IN';
}

interface PointGeometry {
  coordinates: [number, number]; // Array of 2 numbers [x, y]
}

interface PolygonGeometry {
  coordinates: Array<[number, number]>; // Array of coordinate pairs forming the polygon
}

interface GeometryApi {
  type: 'POINT' | 'POLYGON';
  pointGeometry: PointGeometry | null;
  polygonGeometry: PolygonGeometry | null;
}

export interface ResourceType {
  id: string;
  name: string;
  op: string;
}

export enum AvailabilityStatus {
  AVAILABLE = 'AVAILABLE',
  OCCUPIED = 'OCCUPIED',
  UNAVAILABLE = 'UNAVAILABLE',
}

export interface Resource {
  id: string;
  name: string;
  geometry: GeometryApi;
  resourceTypeId: string;
  neighborhoodId: string | null;
  floorId: string;
  assignedTo: string | null;
  assignedProfileData: ProfileData | null;
  availabilityStatus: AvailabilityStatus;
  reservationId: string | null;
  reservedFor: string | null;
  reservedForProfileData: ProfileData | null;
  checkInStatus: CheckInStatus | null;
  amenities: string[];
  featureId: string;
  notes: string | null;
  op: string;
}

export interface LiveMapResponse {
  draftName: string | null;
  companyName: string | null;
  id: string;
  nonce: string;
  code: number;
  floors: Floor[];
  neighborhoods: Neighborhood[];
  amenities: Amenity[];
  resourceTypes: ResourceType[];
  resources: Resource[];
  op: string;
}
